import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { arrowForward } from "ionicons/icons";
import React, { useEffect, useRef, useState } from "react";
import { RouteProps } from "react-router-dom";
import config from "../../../components/helpers/socket/config";
import OneErrorMessage from "../../../utils/component-utils/ErrorMessage/OneErrorMessage";
import { hapticsImpactHeavy } from "../../../utils/core-utils/hapticUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { createPayload } from "../../../utils/sockets/payload";

// @author E42303 Judhjit Ganguli

interface CMEDLoginScreenProps extends RouteProps {
  userAccountData: any;
  mapUserNameToIdAndSelect: Function;
  isCMEDLoggedIn: Boolean;
  loginFaild: any[];
  viewOnly: boolean;
  singleFlag: boolean;
}
const CMEDLoginScreen: React.FC<CMEDLoginScreenProps> = ({
  userAccountData,
  mapUserNameToIdAndSelect,
  isCMEDLoggedIn,
  loginFaild,
  viewOnly,
  singleFlag,
}) => {
  const [selectedAccount, setSelectedAccount] = useState<string>("");
  const timeoutRef = useRef<any>(null);

  useEffect(() => {
    !viewOnly &&
      send(
        config.socket.channels.TRADING,
        createPayload(config.socket.actions.CMED_LOGON, "loginRequest", {}),
      );
  }, []);

  function selectAccount(e: any) {
    const shouldCallNow = !timeoutRef.current;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
    }, 2000);
    if (shouldCallNow) {
      hapticsImpactHeavy();
      mapUserNameToIdAndSelect(e);
      setSelectedAccount(e);
    }
  }

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        {!viewOnly && <IonToolbar></IonToolbar>}
        {isCMEDLoggedIn === false && (
          <IonToolbar className="even_item_bg">
            <IonTitle>CHOOSE AN ACCOUNT</IonTitle>
          </IonToolbar>
        )}
      </IonHeader>

      <IonContent>
        {userAccountData === null && (
          <div
            className="ion-padding"
            style={{
              display: "flex",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <OneErrorMessage errorMsg={loginFaild?.toString()} />
          </div>
        )}
        <IonAccordionGroup className="ion-padding" multiple={true}>
          {singleFlag === true && (
            <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
              <IonAccordion>
                <IonItem slot="header" color="primary">
                  <IonLabel style={{ fontWeight: "bold" }}>
                    {userAccountData?.displayText?.toString()?.toUpperCase()}
                  </IonLabel>
                </IonItem>
                <div slot="content">
                  <IonItem lines="full">
                    <IonLabel className="ion-text-wrap">Internal</IonLabel>
                    <IonLabel className="ion-text-wrap">Permissions</IonLabel>
                  </IonItem>
                  <IonItem lines="none" className="even_item_bg">
                    <IonLabel className="ion-text-wrap">CANCEL ORDERS</IonLabel>
                    {userAccountData?.canCancelMobileOrders
                      ?.toString()
                      ?.toUpperCase() === "TRUE" ? (
                      <IonLabel className="ion-text-wrap" color="medium">
                        Yes
                      </IonLabel>
                    ) : (
                      <IonLabel className="ion-text-wrap" color="medium">
                        No
                      </IonLabel>
                    )}
                  </IonItem>
                  <IonItem lines="full" className="even_item_bg">
                    <IonLabel className="ion-text-wrap">MANAGE ORDERS</IonLabel>
                    {userAccountData?.canManageMobileOrders
                      ?.toString()
                      .toUpperCase() === "TRUE" ? (
                      <IonLabel className="ion-text-wrap" color="medium">
                        Yes
                      </IonLabel>
                    ) : (
                      <IonLabel className="ion-text-wrap" color="medium">
                        No
                      </IonLabel>
                    )}
                  </IonItem>
                  <IonItem lines="full">
                    <IonLabel className="ion-text-wrap">
                      Clearing Member
                    </IonLabel>
                    <IonLabel className="ion-text-wrap">Permissions</IonLabel>
                  </IonItem>
                  {userAccountData?.fcmMobilePermissions?.length > 0 &&
                    userAccountData?.fcmMobilePermissions?.map(
                      (e: any, index: any) => {
                        return (
                          <IonItem
                            lines="none"
                            className="even_item_bg"
                            key={index}
                          >
                            <IonLabel className="ion-text-wrap">
                              {e?.ClearingMemberName}
                            </IonLabel>
                            <IonLabel className="ion-text-wrap" color="medium">
                              {e?.UserLevelPermission}
                            </IonLabel>
                          </IonItem>
                        );
                      },
                    )}
                </div>
              </IonAccordion>
            </div>
          )}
          {singleFlag === false &&
            userAccountData?.map((e: any, index: any) => {
              const FCMPermissions = e?.fcmMobilePermissions;
              const FCMLength = e?.fcmMobilePermissions?.length;
              const canCancel = e?.canCancelMobileOrders
                ?.toString()
                ?.toUpperCase();
              const canManage = e?.canManageMobileOrders
                ?.toString()
                ?.toUpperCase();
              const userName = e?.displayText;
              return (
                <div
                  style={{ display: "flex", gap: 10, alignItems: "flex-start" }}
                  key={index}
                >
                  <IonAccordion>
                    <IonItem slot="header" color="primary">
                      <IonLabel style={{ fontWeight: "bold" }}>
                        {e?.displayText?.toUpperCase()}
                      </IonLabel>
                    </IonItem>
                    <div slot="content">
                      <IonItem lines="full">
                        <IonLabel className="ion-text-wrap">Internal</IonLabel>
                        <IonLabel className="ion-text-wrap">
                          Permissions
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none" className="even_item_bg">
                        <IonLabel className="ion-text-wrap">
                          CANCEL ORDERS
                        </IonLabel>
                        {canCancel === "TRUE" ? (
                          <IonLabel className="ion-text-wrap" color="medium">
                            Yes
                          </IonLabel>
                        ) : (
                          <IonLabel className="ion-text-wrap" color="medium">
                            No
                          </IonLabel>
                        )}
                      </IonItem>
                      <IonItem lines="full" className="even_item_bg">
                        <IonLabel className="ion-text-wrap">
                          MANAGE ORDERS
                        </IonLabel>
                        {canManage === "TRUE" ? (
                          <IonLabel className="ion-text-wrap" color="medium">
                            Yes
                          </IonLabel>
                        ) : (
                          <IonLabel className="ion-text-wrap" color="medium">
                            No
                          </IonLabel>
                        )}
                      </IonItem>
                      <IonItem lines="full">
                        <IonLabel className="ion-text-wrap">
                          Clearing Member
                        </IonLabel>
                        <IonLabel className="ion-text-wrap">
                          Permissions
                        </IonLabel>
                      </IonItem>
                      {FCMLength > 0 &&
                        FCMPermissions?.map((e: any, index: any) => {
                          return (
                            <IonItem
                              lines="none"
                              className="even_item_bg"
                              key={index}
                            >
                              <IonLabel className="ion-text-wrap">
                                {e?.ClearingMemberName}
                              </IonLabel>
                              <IonLabel
                                className="ion-text-wrap"
                                color="medium"
                              >
                                {e?.UserLevelPermission}
                              </IonLabel>
                            </IonItem>
                          );
                        })}
                    </div>
                  </IonAccordion>
                  {!viewOnly && (
                    <IonButton
                      onClick={() => selectAccount(userName)}
                      disabled={
                        selectedAccount?.length > 0 &&
                        selectedAccount !== userName
                      }
                    >
                      <IonIcon slot="icon-only" icon={arrowForward}></IonIcon>
                    </IonButton>
                  )}
                </div>
              );
            })}
        </IonAccordionGroup>
      </IonContent>
    </IonPage>
  );
};

export default CMEDLoginScreen;
